
(function () {
  'use strict';

  var D = window.LZ_DATA || {};
  var routes = D.routes || {};
  var CART_ADD = (routes.cart_add || '/cart/add') + '.js';
  var CART_CHANGE = (routes.cart_change || '/cart/change') + '.js';
  var CART_URL = (routes.cart || '/cart') + '.js';
  var CART_UPDATE = (routes.cart || '/cart') + '/update.js';
  var GIFTS = D.gifts || [];
  var lastCart = D.cart || null;
  var busy = false;
  var needsSync = false;
  var redirecting = false;
  var renderedCartHtml;


  /* ---- formato de moneda ------------------------------------------- */
  /* Ojo: la regex esta escrita asi a proposito para que Liquid no
     interprete la llave doble como etiqueta de salida. */
  var RX = /\{\{\s*(\w+)\s*\}\}/;

  function fmtNumber(cents, decimals, sepDecimal, sepThousand) {
    if (isNaN(cents)) cents = 0;
    var n = (cents / 100.0).toFixed(decimals);
    var parts = n.split('.');
    var int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + sepThousand);
    return parts[1] ? int + sepDecimal + parts[1] : int;
  }

  function money(cents) {
    var fmt = D.money_format || '${{amount}}';
    var m = fmt.match(RX);
    if (!m) return fmt;
    // money_decimals fuerza el redondeo: el precio se muestra sin centavos y
    // asi el drawer coincide con lo que muestra la landing
    var dec = (D.money_decimals === 0 || D.money_decimals > 0)
      ? D.money_decimals
      : (m[1].indexOf('no_decimals') >= 0 ? 0 : 2);
    var miles = ',', decimal = '.';
    if (m[1].indexOf('comma_separator') >= 0) { miles = '.'; decimal = ','; }
    else if (m[1].indexOf('space_separator') >= 0) { miles = ' '; decimal = ','; }
    else if (m[1].indexOf('apostrophe_separator') >= 0) { miles = "'"; }
    return fmt.replace(RX, fmtNumber(cents, dec, decimal, miles));
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  /* ---- regalos del pack ---------------------------------------------
     Envío gratis y el ebook son productos ocultos a $0 (LZ_DATA.gifts).
     Acompañan a cualquier pack: entran junto con él, quedan siempre en 1
     y salen si el carrito se queda sin packs. */

  function giftOf(item) {
    var id = Number(item.variant_id);
    for (var i = 0; i < GIFTS.length; i++) if (GIFTS[i].id === id) return GIFTS[i];
    return null;
  }

  function paidCount(cart) {
    return (cart.items || []).reduce(function (n, item) {
      return giftOf(item) ? n : n + item.quantity;
    }, 0);
  }

  function missingGifts(cart) {
    var items = (cart && cart.items) || [];
    return GIFTS.filter(function (g) {
      return !items.some(function (item) { return Number(item.variant_id) === g.id; });
    }).map(function (g) { return { id: g.id, quantity: 1 }; });
  }

  function syncGifts(cart) {
    if (!GIFTS.length || !cart || !cart.items) return cart;
    var want = paidCount(cart) > 0 ? 1 : 0;
    var updates = null;
    GIFTS.forEach(function (g) {
      var have = cart.items.reduce(function (n, item) {
        return Number(item.variant_id) === g.id ? n + item.quantity : n;
      }, 0);
      if (have !== want) { updates = updates || {}; updates[g.id] = want; }
    });
    if (!updates) return cart;
    return fetch(CART_UPDATE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(readResponse).catch(function () {
      // Los regalos nunca bloquean la compra del pack.
      return cart;
    });
  }

  /* ---- variante seleccionada en la pagina --------------------------- */

  function selectedEl() {
    return document.querySelector('.quantity_item.active') ||
           document.querySelector('.quantity_item.variant-check');
  }

  function selectedVariantId() {
    var el = selectedEl();
    var id = el && el.getAttribute('variant-id');
    return id || D.default_variant_id;
  }

  function selectPack(item) {
    if (busy || redirecting || item.getAttribute('data-available') === 'false') return;
    var previewMessage = document.querySelector('#lz-purchase-status[data-preview-message]');
    if (previewMessage) {
      previewMessage.hidden = true;
      previewMessage.textContent = '';
      previewMessage.removeAttribute('data-preview-message');
    }
    document.querySelectorAll('.quantity_item').forEach(function (el) {
      el.classList.toggle('active', el === item);
      var radio = el.querySelector('input[name="lz-offer-pack"]');
      if (radio) radio.checked = el === item;
    });
    var tab = item.getAttribute('data_tab');
    document.querySelectorAll('.price_trigger').forEach(function (el) {
      var selected = el.getAttribute('data_tab') === tab;
      el.style.display = selected ? '' : 'none';
      el.classList.toggle('active', selected);
    });
    var label = item.getAttribute('label');
    var labelEl = document.querySelector('.product_text_3 strong');
    if (labelEl && label) labelEl.textContent = label;
  }

  /* ---- render del drawer -------------------------------------------- */

  function emptyHtml() {
    return '<div id="cart_drawer_content">' +
      '<div class="cart-content linfozen-cart-content">' +
      '<div class="linfozen-cart-empty cart_empty_content">' +
      '<div class="cart_empty_heading">Tu carrito está vacío</div>' +
      '<div class="cart_empty_button">Seguir comprando</div>' +
      '</div></div></div>';
  }

  function giftLineHtml(item, gift) {
    var img = item.image || '';
    if (img) {
      var imageUrl = new URL(img, window.location.origin);
      imageUrl.searchParams.set('width', '240');
      img = imageUrl.href;
    }
    return '<div class="cart_item_single cart_item_single_flex lz-gift-line" data-key="' + esc(item.key) + '">' +
      '<div class="cart_item_single_left">' +
      '<img class="item_image" src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="80" height="80" decoding="async">' +
      '</div>' +
      '<div class="cart_item_single_right">' +
      '<div class="lz-gift-tag">Regalo incluido</div>' +
      '<div class="cart_item_single_title">' + esc(item.product_title) + '</div>' +
      '<div class="cart_item_single_right_title_right_price">' +
      '<span class="cart_item_single_price">GRATIS</span>' +
      (gift.compare > 0 ? '<s>' + money(gift.compare) + '</s>' : '') +
      '</div>' +
      '</div></div>';
  }

  function lineHtml(item) {
    var gift = giftOf(item);
    if (gift) return giftLineHtml(item, gift);
    var compare = Number(item.original_line_price || 0);
    var price = Number(item.final_line_price || 0);
    // image_url de Liquid ya puede traer width=240. No duplicar el resize.
    var img = item.image || '';
    if (img) {
      var imageUrl = new URL(img, window.location.origin);
      imageUrl.searchParams.set('width', '240');
      img = imageUrl.href;
    }

    return '<div class="cart_item_single cart_item_single_flex" data-key="' + esc(item.key) + '">' +
      '<div class="cart_item_single_left">' +
      '<img class="item_image" src="' + esc(img) + '" alt="' + esc(item.product_title) + '" width="80" height="80" decoding="async">' +
      '</div>' +
      '<div class="cart_item_single_right">' +
      '<div class="product_rating_cart">Calificado 4.9 Excelente</div>' +
      '<div class="cart_item_single_title">' + esc(item.product_title) + '</div>' +
      '<div class="cart_item_single_right_title_right_price">' +
      '<span class="cart_item_single_price">' + money(price) + '</span>' +
      (compare > price ? '<s>' + money(compare) + '</s>' : '') +
      '</div>' +
      '<div class="linfozen-cart-meta">' +
      // Con regalos activos, el envío gratis ya figura como su propia línea.
      (GIFTS.length
        ? esc(item.variant_title || '')
        : (item.variant_title ? esc(item.variant_title) + '<br>' : '') + '+ Envío gratis') +
      '</div>' +
      '<div class="cart_quantity_wrapper lz-qty" data-key="' + esc(item.key) + '">' +
      '<button type="button" class="lz-qty-btn" data-delta="-1" aria-label="Restar uno">−</button>' +
      '<span class="lz-qty-val">' + item.quantity + '</span>' +
      '<button type="button" class="lz-qty-btn" data-delta="1" aria-label="Sumar uno">+</button>' +
      '</div>' +
      '<button type="button" class="cart_item_single_right_remove linfozen-cart-remove" ' +
      'data-key="' + esc(item.key) + '" aria-label="Eliminar producto">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">' +
      '<path d="M18 6L6 18M6 6l12 12" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '</div></div>';
  }

  function cartHtml(cart) {
    var save = Number(cart.original_total_price || 0) - Number(cart.total_price || 0);
    // Los regalos suman su valor de referencia al ahorro y van debajo de los packs.
    cart.items.forEach(function (item) {
      var gift = giftOf(item);
      if (gift) save += gift.compare * item.quantity;
    });
    var lines = cart.items.filter(function (item) { return !giftOf(item); })
      .concat(cart.items.filter(giftOf)).map(lineHtml).join('');

    return '<div id="cart_drawer_content">' +
      '<div class="cart-content linfozen-cart-content">' +
      '<div class="cart_heading">Tu carrito</div>' +
      '<div class="linfozen-cart-item-wrap"><div class="cart_middle">' + lines + '</div></div>' +
      '<div class="cart_footer">' +
      '<div class="cart_footer_top">' +
      '<div class="cart_footer_subtotal_title">Subtotal</div>' +
      '<div class="cart_footer_subtotal_right">' +
      (save > 0 ? '<div class="cart_footer_subtotal_save">Ahorras ' + money(save) + '</div>' : '') +
      '<div class="cart_footer_subtotal_price">' + money(cart.total_price) + '</div>' +
      '</div></div>' +
      '<a class="checkout_button" href="' + (routes.checkout || '/checkout') + '">Continuar al pago</a>' +
      '<div class="under_cta_texts">' +
      '<div class="under_cta_text">Garantía de 60 días</div>' +
      pagosHtml() +
      '</div>' +
      '</div></div></div>';
  }

  /* Tira de medios de pago: los mismos logos que la ficha, pintados desde JS
     porque el drawer se arma en el cliente. */
  function pagosHtml() {
    var lista = D.pagos || [];
    if (!lista.length) return '';
    var tiles = lista.map(function (p) {
      return '<span class="lz-pago lz-pago--' + esc(p.c) + '">' +
        '<img src="' + esc(p.u) + '" alt="' + esc(p.n) + '" loading="lazy" decoding="async">' +
        '</span>';
    }).join('');
    return '<div class="lz-pagos lz-pagos--drawer">' + tiles + '</div>';
  }

  function setCount(n) {
    document.querySelectorAll('.cart_count_js').forEach(function (el) {
      el.textContent = String(n);
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  function render(cart) {
    needsSync = false;
    if (cart && cart.items) lastCart = cart;
    var drawer = document.getElementById('cart-drawer');
    var current = document.getElementById('cart_drawer_content');
    if (!drawer || !current) return;
    // Un carrito con solo regalos se muestra vacío (la sincronización los quita).
    var empty = !cart || !cart.items || !paidCount(cart);
    var nextHtml = empty ? emptyHtml() : cartHtml(cart);
    // Una lectura sin cambios conserva los controles y el foco del usuario.
    // Precios, cantidades, descuentos o líneas distintos sí reconstruyen el panel.
    if (nextHtml !== renderedCartHtml) {
      current.outerHTML = nextHtml;
      renderedCartHtml = nextHtml;
    }
    drawer.classList.toggle('is_empty', empty);
    setCount(empty ? 0 : paidCount(cart));
    updateControls();
  }

  /* ---- red ---------------------------------------------------------- */

  function readResponse(r) {
    return r.json().then(function (data) {
      if (!r.ok || data.status >= 400) {
        var error = new Error(data.description || 'No pudimos actualizar tu carrito.');
        error.status = r.status;
        throw error;
      }
      return data;
    });
  }

  function getCart() {
    return fetch(CART_URL, { cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(readResponse);
  }

  function cartFromSections(data) {
    var html = data.sections && data.sections['lz-cart-state'];
    if (html) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cart = JSON.parse(doc.querySelector('[data-lz-cart-state]').textContent);
        if (Array.isArray(cart.items) && typeof cart.total_price === 'number') return cart;
      } catch (_) { /* Shopify puede devolver una seccion nula o incompleta. */ }
    }
    // Solo consultar aparte si Shopify no pudo renderizar la seccion.
    return getCart();
  }

  function postAdd(items) {
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['lz-cart-state'],
        sections_url: (routes.cart || '/cart')
      })
    }).then(readResponse);
  }

  function addToCart(id, qty) {
    var pack = [{ id: Number(id), quantity: qty || 1 }];
    var gifts = missingGifts(lastCart);
    // El pack y sus regalos viajan en un solo pedido.
    return postAdd(pack.concat(gifts)).catch(function (error) {
      // 422 = Shopify rechazó todo el pedido sin guardar nada: reintentar solo el pack.
      if (!gifts.length || error.status !== 422) throw error;
      return postAdd(pack);
    }).then(cartFromSections);
  }

  function changeLine(key, quantity) {
    return fetch(CART_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(readResponse);
  }

  /* ---- drawer ------------------------------------------------------- */

  function toggleDrawer(open) {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.querySelector('.custom_overlay2');
    if (drawer) drawer.classList.toggle('open', open);
    if (overlay) overlay.classList.toggle('active', open);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  function status(message, error) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    var el = document.getElementById('lz-cart-status');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lz-cart-status';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      drawer.appendChild(el);
    }
    el.hidden = !message;
    el.textContent = message || '';
    if (error) {
      var link = document.createElement('a');
      link.href = routes.cart || '/cart';
      link.textContent = ' Revisar carrito';
      el.appendChild(link);
    }
  }

  function updateControls() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.setAttribute('aria-busy', String(busy));
    document.querySelectorAll('.lz-qty-btn, .linfozen-cart-remove').forEach(function (el) {
      el.disabled = busy || needsSync;
    });
    document.querySelectorAll('.checkout_button').forEach(function (el) {
      el.setAttribute('aria-disabled', String(busy || needsSync));
    });
    document.querySelectorAll('input[name="lz-offer-pack"]').forEach(function (el) {
      el.disabled = busy || redirecting || el.closest('.quantity_item').getAttribute('data-available') === 'false';
    });
    document.querySelectorAll(ADD_SEL).forEach(function (el) {
      el.classList.toggle('is-loading', busy || redirecting);
      el.setAttribute('aria-disabled', String(busy || redirecting));
      if (el.tagName === 'BUTTON') el.disabled = busy || redirecting;
    });
  }

  function requestCart(request, message, mutating) {
    if (busy || redirecting) return;
    var result = { ok: false, error: '' };
    busy = true;
    needsSync = true;
    updateControls();
    status(message);
    return request().then(syncGifts).then(function (cart) {
      render(cart);
      status('');
      result.ok = true;
    }).catch(function (error) {
      var message = error.message || 'No pudimos actualizar tu carrito.';
      result.error = message;
      // Un POST incierto no se repite: consultar lo que realmente guardo Shopify.
      if (mutating) {
        return getCart().then(render).catch(function () {}).then(function () {
          status(message, true);
        });
      }
      status('No pudimos verificar tu carrito. Revisa tu conexión.', true);
    }).then(function () {
      busy = false;
      updateControls();
      return result;
    });
  }

  function restoreCheckoutButton(button) {
    var content = button.getAttribute('data-lz-idle-content');
    if (content === null) return;
    button.innerHTML = content;
    button.removeAttribute('data-lz-idle-content');
  }

  function startCheckout(button) {
    if (busy || redirecting) return;
    var id = selectedVariantId();
    if (!id || (selectedEl() && selectedEl().getAttribute('data-available') === 'false')) return;
    var message = document.getElementById('lz-purchase-status');
    if (selectedEl() && selectedEl().getAttribute('data-preview-only') === 'true') {
      if (message) {
        message.hidden = false;
        message.textContent = 'Pack de 5: vista previa. Falta activar esta variante en Shopify.';
        message.setAttribute('data-preview-message', 'true');
      }
      return;
    }
    if (message) { message.hidden = true; message.textContent = ''; }
    button.setAttribute('data-lz-idle-content', button.innerHTML);
    button.textContent = button.hasAttribute('data-lz-add-only') ? 'Agregando…' : 'Procesando…';
    // Cada variante representa el pack completo, igual que Añadir al carrito.
    requestCart(function () { return addToCart(id, 1); }, 'Preparando tu compra…', true)
      .then(function (result) {
        if (result.ok) {
          redirecting = true;
          updateControls();
          // Un enlace conserva la landing en el historial incluso antes de load.
          // location.assign puede reemplazarla si la activación del clic expiró.
          var checkoutLink = document.createElement('a');
          checkoutLink.href = button.hasAttribute('data-lz-add-only')
            ? (routes.cart || '/cart') : (routes.checkout || '/checkout');
          checkoutLink.target = '_self';
          checkoutLink.hidden = true;
          document.body.appendChild(checkoutLink);
          checkoutLink.click();
          checkoutLink.remove();
          return;
        }
        restoreCheckoutButton(button);
        if (message) {
          message.hidden = false;
          message.textContent = result.error + ' Revisa tu carrito antes de volver a intentar. ';
          var link = document.createElement('a');
          link.href = routes.cart || '/cart';
          link.textContent = 'Ver carrito';
          message.appendChild(link);
        }
        // Los CTA inferiores muestran el error en el carrito, cerca del usuario.
        if (!button.closest('.lz-purchase-actions')) toggleDrawer(true);
      });
  }

  function openCart() {
    if (busy || redirecting) return;
    var link = document.createElement('a');
    link.href = routes.cart || '/cart';
    link.hidden = true;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  /* ---- eventos ------------------------------------------------------ */

  var ADD_SEL = '.add-to-cart-btn, .custom_checkout_button, .custom_lp_button, ' +
                '.sticky-bar__button, #sticky-cta, a.buylink';

  function init() {
    // el carrito viene embebido desde Liquid: el primer pintado no pide /cart.js
    if (D.cart) render(D.cart);

    document.addEventListener('click', function (e) {
      var pack = e.target.closest && e.target.closest('.quantity_item');
      if (pack) {
        selectPack(pack);
        return;
      }
      var add = e.target.closest && e.target.closest(ADD_SEL);
      if (add) {
        e.preventDefault();
        startCheckout(add);
        return;
      }

      var toggle = e.target.closest && e.target.closest('#cart-toggle, .cart_count_js');
      if (toggle) { e.preventDefault(); openCart(); return; }

      var checkout = e.target.closest && e.target.closest('.checkout_button');
      if (checkout) {
        e.preventDefault();
        if (busy || needsSync || redirecting) return;
        redirecting = true;
        updateControls();
        window.location.assign(checkout.href);
        return;
      }

      if (e.target.closest && e.target.closest('#cart-close, .cart_empty_button, .custom_overlay2')) {
        e.preventDefault(); toggleDrawer(false); return;
      }

      var qty = e.target.closest && e.target.closest('.lz-qty-btn');
      if (qty) {
        e.preventDefault();
        if (busy || needsSync) return;
        var wrap = qty.closest('.lz-qty');
        var key = wrap.getAttribute('data-key');
        var val = parseInt(wrap.querySelector('.lz-qty-val').textContent, 10) || 1;
        var next = val + parseInt(qty.getAttribute('data-delta'), 10);
        requestCart(function () { return changeLine(key, Math.max(0, next)); }, 'Actualizando cantidad…', true);
        return;
      }

      var rm = e.target.closest && e.target.closest('.linfozen-cart-remove');
      if (rm) {
        e.preventDefault();
        if (busy || needsSync) return;
        requestCart(function () { return changeLine(rm.getAttribute('data-key'), 0); }, 'Quitando producto…', true);
      }
    });

    document.addEventListener('change', function (e) {
      if (e.target.matches('input[name="lz-offer-pack"]')) selectPack(e.target.closest('.quantity_item'));
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') toggleDrawer(false);
    });

    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !redirecting) return;
      redirecting = false;
      document.querySelectorAll('[data-lz-idle-content]').forEach(restoreCheckoutButton);
      updateControls();
    });
    window.LZ_CART.ready = true;
    if (window.LZ_EARLY_CART) window.LZ_EARLY_CART.flush();
  }

  window.LZ_CART = { open: openCart, render: render, money: money, selectPack: selectPack, ready: false };
  // El script async sale después del header/drawer y LZ_DATA. Los eventos
  // delegados atienden los packs y CTA que siguen; no espera DOMContentLoaded.
  init();
})();
